// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6909":"3d5eef9b","8084":"a4b73740"}[chunkId] + ".chunk.css";
};